import { render, staticRenderFns } from "./heron6000_132411.vue?vue&type=template&id=b3963042&scoped=true"
import script from "./heron6000_132411.vue?vue&type=script&lang=js"
export * from "./heron6000_132411.vue?vue&type=script&lang=js"
import style0 from "./heron6000_132411.vue?vue&type=style&index=0&id=b3963042&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b3963042",
  null
  
)

export default component.exports